import { Response } from '@/domain/vo/BaseResponse';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import authService from '@/services/AuthService';
import { DataResponse } from '@/common/Response';
import { AxiosError } from 'axios';
import { IUserLoginResponse } from '../types';
import { ILoginVariables } from '@/domain/auth/entities';

const Login = async (
  input: ILoginVariables,
): Promise<DataResponse<IUserLoginResponse>> => {
  const response = await authService.login({ ...input });
  return response;
};

export const useLoginMutation = (
  options: UseMutationOptions<
    DataResponse<IUserLoginResponse>,
    AxiosError<Response>,
    ILoginVariables
  >,
) =>
  useMutation({
    mutationFn: Login,
    ...options,
  });
